export const translations = {
  EN: {
    // Header
    home: "Home",
    services: "Services",
    about: "About",
    team: "Team",
    portfolio: "Portfolio",
    contact: "Contact",
    careersNav: "Careers",
    
    // Banner
    subtitle: "Welcome to Elyptek",
    mainHeading: "Digital Marketing & Software Solutions",
    highlight: "Innovation",
    lead: "We help businesses grow with cutting-edge digital solutions",
    learnMore: "Learn More",
    getStarted: "Get Started",
    
    // Services
    servicesTitle: "Our Services",
    servicesSubtitle: "What We Do",
    servicesDescription: "Discover our comprehensive range of digital services designed to elevate your business",
    
    // About
    aboutTitle: "About Us",
    aboutSubtitle: "Who We Are",
    aboutDescription: "Learn about our mission, values, and the team behind Elyptek",
    
    // Team
    teamTitle: "Our Team",
    teamSubtitle: "Meet Our Experts",
    teamDescription: "Get to know the talented professionals who make Elyptek exceptional",
    
    // Portfolio
    portfolioTitle: "Our Portfolio",
    portfolioSubtitle: "Recent Work",
    portfolioDescription: "Explore Elyptek projects and clients — websites designed and developed by Elyptek across industries. See the customer work we have built",
    
    // Contact
    contactTitle: "Contact Us",
    contactSubtitle: "Get In Touch",
    contactDescription: "Connect with us today to explore your needs and discover how we can <em>support you</em>",
    contactSubDescription: "Ready to start your next project? Get in touch with our team and let's discuss how we can bring your vision to life.",
    
    // Form
    name: "Your Name",
    email: "Your Email",
    mobile: "Mobile Number",
    message: "Your Message",
    sendMessage: "Send Message Now",
    sending: "Sending...",
    
    // Careers / job application
    jobApplicationTitle: "Careers",
    jobApplicationHero: "Apply to join Elyptek",
    jobApplicationDescription: "Share your background and the role you're interested in. Our team reviews every application.",
    jobPositionLabel: "Role / position",
    jobPositionPlaceholder: "e.g. Frontend developer, UX designer…",
    jobExperienceLabel: "Years of experience",
    jobExperienceOption: "Select range",
    jobExperienceGraduate: "Student / Recent graduate",
    jobExperienceLt2: "1–2 years",
    jobExperience2to5: "3–5 years",
    jobExperienceGt5: "5+ years",
    jobLinkedInLabel: "LinkedIn (optional)",
    jobCvLinkLabel: "CV or portfolio link (optional)",
    jobCvLinkPlaceholder: "Link to Drive, Dropbox, Behance…",
    jobCoverLetterLabel: "Cover letter",
    jobCoverLetterPlaceholder: "Why Elyptek? What would you bring to the team?",
    jobSubmit: "Submit application",
    jobSubmitSuccess: "Application sent successfully. We'll be in touch if there's a fit.",
    jobSubmitError: "Something went wrong. Please try again or email {{email}}.",
    jobCvPdfLabel: "Upload CV — PDF or image (optional)",
    jobCvPdfSelected: "Selected: {{name}}",
    jobCvPdfErrorType: "Please upload a PDF, JPG, PNG, or WEBP file.",
    jobCvPdfErrorSize: "File is too large (max {{sizeMB}} MB).",
    jobCvPdfErrorRead: "Could not read the file — try another.",
    jobCvPdfClear: "Remove file",
    jobLogoHomeAria: "Go to Elyptek.com home",
    
    // Footer
    footerQuote: "Empowering businesses through innovative digital solutions",
    quickLinks: "Quick Links",
    contactInfo: "Contact Information",
    copyright: "© 2026 Elyptek. All rights reserved.",
    
    // Country codes (keep as is since they're already in English)
    countryCodes: [
      { code: '+1', label: 'USA/Canada' },
      { code: '+44', label: 'United Kingdom' },
      { code: '+49', label: 'Germany' },
      { code: '+33', label: 'France' },
      { code: '+39', label: 'Italy' },
      { code: '+34', label: 'Spain' },
      { code: '+7', label: 'Russia' },
      { code: '+81', label: 'Japan' },
      { code: '+86', label: 'China' },
      { code: '+91', label: 'India' },
      { code: '+61', label: 'Australia' },
      { code: '+64', label: 'New Zealand' },
      { code: '+55', label: 'Brazil' },
      { code: '+52', label: 'Mexico' },
      { code: '+27', label: 'South Africa' },
      { code: '+20', label: 'Egypt' },
      { code: '+971', label: 'UAE' },
      { code: '+966', label: 'Saudi Arabia' },
      { code: '+90', label: 'Turkey' },
      { code: '+963', label: 'Syria' },
      { code: '+962', label: 'Jordan' },
      { code: '+961', label: 'Lebanon' },
      { code: '+965', label: 'Kuwait' },
      { code: '+974', label: 'Qatar' },
      { code: '+968', label: 'Oman' },
      { code: '+973', label: 'Bahrain' },
      { code: '+82', label: 'South Korea' },  
      { code: '+60', label: 'Malaysia' },
      { code: '+65', label: 'Singapore' },
      { code: '+66', label: 'Thailand' },
    ]
  },
  
  AR: {
    // Header
    home: "الرئيسية",
    services: "الخدمات",
    about: "من نحن",
    team: "الفريق",
    portfolio: "أعمالنا",
    contact: "اتصل بنا",
    careersNav: "التوظيف",
    
    // Banner
    subtitle: "مرحباً بكم في إيليبتك",
    mainHeading: "حلول التسويق الرقمي والبرمجيات",
    highlight: "الابتكار",
    lead: "نساعد الشركات على النمو من خلال حلول رقمية متطورة",
    learnMore: "اعرف المزيد",
    getStarted: "ابدأ الآن",
    
    // Services
    servicesTitle: "خدماتنا",
    servicesSubtitle: "ماذا نقدم",
    servicesDescription: "اكتشف مجموعة شاملة من الخدمات الرقمية المصممة لرفع مستوى عملك",
    
    // About
    aboutTitle: "من نحن",
    aboutSubtitle: "تعرف علينا",
    aboutDescription: "تعرف على مهمتنا وقيمنا والفريق وراء إيليبتك",
    
    // Team
    teamTitle: "فريقنا",
    teamSubtitle: "تعرف على خبرائنا",
    teamDescription: "تعرف على المحترفين الموهوبين الذين يجعلون إيليبتك استثنائية",
    
    // Portfolio
    portfolioTitle: "أعمالنا",
    portfolioSubtitle: "أحدث الأعمال",
    portfolioDescription: "استكشف مشاريع وعملاء إيليبتك — مواقع صمّمتها وطوّرتها إيليبتك عبر قطاعات متعددة. اطّلع على أعمال العملاء التي بنيناها",
    
    // Contact
    contactTitle: "اتصل بنا",
    contactSubtitle: "تواصل معنا",
    contactDescription: "تواصل معنا اليوم لاستكشاف احتياجاتك واكتشاف كيف يمكننا <em>دعمك</em>",
    contactSubDescription: "مستعد لبدء مشروعك القادم؟ تواصل مع فريقنا ودعنا نناقش كيف يمكننا تحقيق رؤيتك",
    
    // Form
    name: "اسمك",
    email: "بريدك الإلكتروني",
    mobile: "رقم الجوال",
    message: "رسالتك",
    sendMessage: "أرسل الرسالة الآن",
    sending: "جاري الإرسال...",
    
    // Careers / job application
    jobApplicationTitle: "فرص عمل",
    jobApplicationHero: "انضم إلى فريق إيليبتك",
    jobApplicationDescription: "شاركنا خلفيتك والوظيفة التي تهتم لها. يراجع فريقنا جميع الطلبات.",
    jobPositionLabel: "المسمّى أو المجال",
    jobPositionPlaceholder: "مثال: مطوّر واجهات، مصمّم تجربة مستخدم…",
    jobExperienceLabel: "سنوات الخبرة",
    jobExperienceOption: "اختر المدى",
    jobExperienceGraduate: "طالب / حديث تخرّج",
    jobExperienceLt2: "1–2 سنة",
    jobExperience2to5: "3–5 سنوات",
    jobExperienceGt5: "+5 سنوات",
    jobLinkedInLabel: "لينكد إن (اختياري)",
    jobCvLinkLabel: "رابط السيرة الذاتية أو معرض الأعمال (اختياري)",
    jobCvLinkPlaceholder: "رابط درايف أو دروببوكس أو بيهانس…",
    jobCoverLetterLabel: "خطاب تعريفي",
    jobCoverLetterPlaceholder: "لماذا إيليبتك؟ وماذا تضيف للفريق؟",
    jobSubmit: "إرسال الطلب",
    jobSubmitSuccess: "تم إرسال طلبك بنجاح. سنتواصل عند وجود تناسب.",
    jobSubmitError: "تعذّر الإرسال. حاول مجدداً أو راسلنا على {{email}}",
    jobCvPdfLabel: "رفع السيرة — PDF أو صورة (اختياري)",
    jobCvPdfSelected: "الملف المختار: {{name}}",
    jobCvPdfErrorType: "استخدم ملف PDF أو JPG أو PNG أو WEBP.",
    jobCvPdfErrorSize: "الملف أكبر من المسموح (حتى {{sizeMB}} ميغابايت).",
    jobCvPdfErrorRead: "تعذّر قراءة الملف — جرّب ملفاً آخر.",
    jobCvPdfClear: "إزالة الملف",
    jobLogoHomeAria: "الانتقال إلى الصفحة الرئيسية Elyptek.com",
    
    // Footer
    footerQuote: "تمكين الشركات من خلال الحلول الرقمية المبتكرة",
    quickLinks: "روابط سريعة",
    contactInfo: "معلومات الاتصال",
    copyright: "© 2026 Elyptek. جميع الحقوق محفوظة.",
    
    // Country codes in Arabic
    countryCodes: [
      { code: '+1', label: 'الولايات المتحدة/كندا' },
      { code: '+44', label: 'المملكة المتحدة' },
      { code: '+49', label: 'ألمانيا' },
      { code: '+33', label: 'فرنسا' },
      { code: '+39', label: 'إيطاليا' },
      { code: '+34', label: 'إسبانيا' },
      { code: '+7', label: 'روسيا' },
      { code: '+81', label: 'اليابان' },
      { code: '+86', label: 'الصين' },
      { code: '+91', label: 'الهند' },
      { code: '+61', label: 'أستراليا' },
      { code: '+64', label: 'نيوزيلندا' },
      { code: '+55', label: 'البرازيل' },
      { code: '+52', label: 'المكسيك' },
      { code: '+27', label: 'جنوب أفريقيا' },
      { code: '+20', label: 'مصر' },
      { code: '+971', label: 'الإمارات' },
      { code: '+966', label: 'السعودية' },
      { code: '+90', label: 'تركيا' },
      { code: '+963', label: 'سوريا' },
      { code: '+962', label: 'الأردن' },
      { code: '+961', label: 'لبنان' },
      { code: '+965', label: 'الكويت' },
      { code: '+974', label: 'قطر' },
      { code: '+968', label: 'عمان' },
      { code: '+973', label: 'البحرين' },
      { code: '+82', label: 'كوريا الجنوبية' },  
      { code: '+60', label: 'ماليزيا' },
      { code: '+65', label: 'سنغافورة' },
      { code: '+66', label: 'تايلاند' },
    ]
  }
};

// Helper function to get current translation
export const getTranslation = (key, language = 'EN') => {
  return translations[language]?.[key] || translations['EN'][key] || key;
};

// Helper function to get country codes for current language
export const getCountryCodes = (language = 'EN') => {
  return translations[language]?.countryCodes || translations['EN'].countryCodes;
}; 